import {useRoutes} from 'react-router-dom';
import {Suspense} from 'react';
import {ConfigProvider} from 'antd';
import zhCn from 'antd/lib/locale-provider/zh_CN';
import {routes} from '@/routes';

const App = () => {
    const element = useRoutes(routes);
    return (
        <ConfigProvider locale={zhCn}>
            <Suspense fallback={null}>
                {element}
            </Suspense>
        </ConfigProvider>
    );
};

export default App;
